import React from 'react';

import Badge from '../common/Badge';

// Mirrors StatusBadge.jsx's pattern for users - maps a meeting's
// lifecycle status (models/meeting.py's MeetingStatus: scheduled/
// active/paused/ended) to a label/variant. deleted_at is a separate
// column, not a MeetingStatus value (see models/meeting.py), so a
// soft-deleted meeting is passed in as status="deleted" by the caller
// to take priority over whatever lifecycle status it was deleted in.
// The status is whatever the backend stored: a live meeting is ACTIVE ("Running",
// green), and one that ended, hit its time limit or was abandoned (the
// meeting reaper finalizes those) is ENDED (gray). Nothing is inferred here.
const STATUS_CONFIG = {
  scheduled: { label: 'Scheduled', variant: 'reconnecting' },
  active: { label: 'Running', variant: 'listening' },
  paused: { label: 'Paused', variant: 'paused' },
  ended: { label: 'Ended', variant: 'neutral' },
  deleted: { label: 'Deleted', variant: 'disconnected' },
};

function MeetingStatusBadge({ status, deletedAt }) {
  const effectiveStatus = deletedAt ? 'deleted' : status;
  const config = STATUS_CONFIG[effectiveStatus] || { label: effectiveStatus, variant: 'neutral' };

  return <Badge variant={config.variant}>{config.label}</Badge>;
}

export default MeetingStatusBadge;
